import type { ReactNode } from 'react';

import { Box } from '#/components/Box/Box';
import { Button } from '#/components/Button/Button';
import { Icon } from '#/components/Icon/Icon';
import { Text } from '#/components/Text/Text';

import {
  BreadcrumbsAllLinksHolder,
  BreadcrumbsBackLinkOnlyHolder,
  LinkContainer,
  Separator,
  StyledRouterLink,
} from './Breadcrumbs.styled';

export type BreadcrumbLink = {
  qaId?: string;
  title: ReactNode;
  to?: string;
  state?: Record<string, unknown>;
};

type Props = {
  qaId?: string;
  links: BreadcrumbLink[];
};

export function Breadcrumbs({ links, qaId }: Props) {
  const backLinkHref = links.at(-2)?.to || null;

  return (
    <Box component={Text} styleAs="bodySmall" qaId={qaId ?? 'breadcrumbs'}>
      {backLinkHref && (
        <BreadcrumbsBackLinkOnlyHolder>
          <Button
            variant="link"
            type="link"
            href={backLinkHref}
            icon={{ name: 'chevron-left' }}
            noPadding
          >
            Back
          </Button>
        </BreadcrumbsBackLinkOnlyHolder>
      )}

      <BreadcrumbsAllLinksHolder $noBackLink={!backLinkHref}>
        {links.map(({ title, to, state, ...linkProps }, index) => (
          <LinkContainer
            key={to ?? (typeof title === 'string' ? title : `crumb-${index}`)}
          >
            {index > 0 && (
              <Separator>
                <Icon name="chevron-left" size={11} />
              </Separator>
            )}
            <Box
              component={to ? StyledRouterLink : undefined}
              // @ts-expect-error replace Box with the component
              to={to ?? undefined}
              state={state}
              whiteSpace="nowrap"
              overflow="hidden"
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...linkProps}
            >
              {title}
            </Box>
          </LinkContainer>
        ))}
      </BreadcrumbsAllLinksHolder>
    </Box>
  );
}
